import * as Inspector from 'avo-inspector'

// eslint-disable-next-line import/no-default-export
export default Inspector
